package org.example.project.yard

import org.example.project.service.YardEngineApi
import org.example.project.utils.All

data class WeTorAssignmentResult(
    val auftrag: All,
    val torSuggested: Boolean
)

suspend fun suggestWeTorOnArrival(auftrag: All, firmenId: String = ""): WeTorAssignmentResult {
    val result = YardEngineApi.suggestWeTor(auftrag, firmenId.ifBlank { auftrag.firmenId })
    return result?.let { WeTorAssignmentResult(it.auftrag, it.torSuggested) }
        ?: WeTorAssignmentResult(auftrag, torSuggested = false)
}
